import React from "react";
import { DownOutlined } from "@ant-design/icons";
// custom types
import { Language } from "types";
// graphql
// styling
import LanguageFilterCommon from "common/language_filter";

type LanguageFilterProps = {
  onChangeOtherFilterFields: (
    field: string,
    value: string | number | number[] | boolean
  ) => void;
  filterLanguage: {
    id: string;
  };
  languages: Language[];
  refetchBanner: (variables: any) => void;
};

function LanguagesFiler(props: LanguageFilterProps) {
  const {
    onChangeOtherFilterFields,
    filterLanguage,
    languages,
    refetchBanner,
  } = props;

  const handleChange = (value: any) => {
    refetchBanner({ id: value });
    onChangeOtherFilterFields("language", value as string);
  };

  return (
    <div>
      <LanguageFilterCommon
        onChange={handleChange}
        filterLanguageId={filterLanguage.id}
        languages={languages}
        isLeftAlign={false}
        dropIcon={<DownOutlined className="value-dropdown-icon" />}
      />
    </div>
  );
}

export default LanguagesFiler;
